import Vue from 'vue'

Vue.component('video-categories', require('./components/VideoCategories'))
Vue.component('grid-videos', require('./components/GridVideos'))

const app = new Vue({
    el: "#app",
    data: {
        activeVideoCategory: "all",
    }
})
